import buildMonster from './buildMonster'

export default initScene = (cb) ->
  buildMonster(cb)

  AFRAME.scenes[0].object3D.add(new THREE.Fog(0x000000, 1, 100))
